import { useTranslation } from 'react-i18next';
import { Typography } from '@dagensmat/carrot/Components';
import { Container } from '@dagensmat/carrot/Layout';
import { ButtonAnchor } from '_common/components/button/Button.style';

type OrderListHeadingProps = {
  settlementNumber: string;
  attachmentUrl?: string;
};

const OrderListHeading = ({
  settlementNumber,
  attachmentUrl
}: OrderListHeadingProps) => {
  const { t } = useTranslation();
  return (
    <Container flex justify="space-between" alignItems="center">
      <Typography variant="tertiaryHeading" as="h2" mb="none">
        {`${t('producer:Settlement')} ${settlementNumber}`}
      </Typography>
      {!!attachmentUrl && (
        <ButtonAnchor
          target="_blank"
          rel="noopener noreferrer"
          href={attachmentUrl}
          variant="borderless"
        >
          {t('producer:DownloadSettlement')}
        </ButtonAnchor>
      )}
    </Container>
  );
};

export default OrderListHeading;
